// extracted by mini-css-extract-plugin
export default {"active":"search-button__active__tncfm"};